import { useState } from "react";
import Header from "@/components/Header";
import LifeHeroSection from "@/components/LifeHeroSection";
import LifeHowItWorks from "@/components/LifeHowItWorks";
import LifeDiagnosticQuiz from "@/components/LifeDiagnosticQuiz";
import LifeResultsSection from "@/components/LifeResultsSection";
import Footer from "@/components/Footer";

const LifeQuiz = () => {
  const [showQuiz, setShowQuiz] = useState(false);
  const [results, setResults] = useState(null);
  const [userName, setUserName] = useState("");

  const handleStartQuiz = () => {
    setShowQuiz(true);
    setResults(null);
    setTimeout(() => {
      document.getElementById('quiz')?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  const handleQuizComplete = (quizResults, userData) => {
    setResults(quizResults);
    setUserName(userData.name);
    setShowQuiz(false);
    setTimeout(() => {
      document.getElementById('results')?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  const handleRetakeQuiz = () => {
    localStorage.removeItem('siwon_life_quiz_results');
    localStorage.removeItem('siwon_life_user_data');
    setResults(null);
    setShowQuiz(true);
    setTimeout(() => {
      document.getElementById('quiz')?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  return (
    <div className="min-h-screen" data-testid="life-quiz-page">
      <Header />
      
      {/* Hero Section - show when not in quiz or results */}
      {!showQuiz && !results && (
        <LifeHeroSection onStartQuiz={handleStartQuiz} />
      )}

      {/* How It Works - show when not in quiz/results */}
      {!showQuiz && !results && (
        <LifeHowItWorks />
      )}

      {/* Quiz Section */}
      {showQuiz && !results && (
        <LifeDiagnosticQuiz onComplete={handleQuizComplete} />
      )}

      {/* Results Section */}
      {results && (
        <>
          <div className="pt-20" />
          <LifeResultsSection results={results} userName={userName} />
          <div className="bg-cream-dark py-8 text-center">
            <button
              onClick={handleRetakeQuiz}
              className="text-primary hover:text-accent transition-colors font-medium underline underline-offset-4"
              data-testid="retake-life-quiz-btn"
            >
              Retake the Diagnostic Quiz
            </button>
          </div>
        </>
      )}

      <Footer onStartQuiz={handleStartQuiz} />
    </div>
  );
};

export default LifeQuiz;
